import React, { Component } from 'react';
import Cookie from 'js-cookie';
import { Config } from '../config/config';
import Menu from './Menu';
import Header from './Header';
import uuid from 'react-uuid';
import Footer from './Footer';
import CheckEdit from './CheckEdit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Navigate } from 'react-router-dom';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import MessageBoxForInvalidPage from '../UIComponents/MessageBox/MessageBoxForInvalidPage';
import LZString from 'lz-string';


class EditChecklist extends Component {
  constructor(props) {
    super(props);
    const config = JSON.parse(Config);
    // let stores = JSON.parse(Cookie.get('stores'));
    // let wareHouses = JSON.parse(Cookie.get('warehouses'));
    let stores = JSON.parse(localStorage.getItem('storeData'));
    let wareHouses = JSON.parse(localStorage.getItem('warehouseData'));
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    localStorage.removeItem('store_tabName');
    localStorage.removeItem('warehouse_tabName');
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    const menu = user['moduleAccess'];

    let date = new Date();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    let year = date.getFullYear();
    var daynow = new Date();
    daynow.setDate(daynow.getDate());
    var dateStringNow = daynow.toISOString().split('T')[0];

    var dayst = new Date();
    dayst.setDate(dayst.getDate() - 30);
    var dateString = dayst.toISOString().split('T')[0];

    this.state = {
      title: 'Edit Check Lists',
      data: [],
      selectOption: true,
      items: [],
      id: uuid(),
      item: '',
      editItem: false,
      alert: '',
      cgName: '',
      checkName: '',
      incType: '',
      checklistGroupId: '',
      user: menu,
      pageAllowed: false,
      storeValue: '',
      storeSelected: false,
      closure: '',

      wareHouses,
      stores,
      category: [],
      modalOpen: false,
      visible: false,
      tableVisible: false,
      month: month,
      day: day,

      year,
      FromDate: dateString,
      ToDate: dateStringNow,
      codeJson: [],
      submittedByCodeJson: [],
      message: '',
      apiInterface: config['api'],
      proxyjson: [],
      loading: false,
      dataEmpty: false,
      submittedBy: '',
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleStoreValue = (event) => {
    this.setState({
      storeValue: event.target.value,
      loading: true,
      alert: '',
      incType: '',
      checklistGroupId: '',
      cgName: '',
      chechGroupId: '',
      selectOption: true,
      data: [],
      category: [],
    });

    ApiGateWay.paramsPost(
      this.state.apiInterface +
        '/loadHandoverNames?storeId=' +
        event.target.value +
        '&type=All',
      JSON.parse(Cookie.get('token'))
    )
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');
          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        this.setState({
          codeJson: response,
          loading: false,
          storeSelected: true,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
    this.setState({
      storeValue: event.target.value,
      loading: true,

      selectOption: true,
      data: [],
    });
  };
  handleAlert = (event) => {
    let chechGroupId = event.target.value;

    let cgId = chechGroupId.split('+');

    if (cgId[0] === 'null') {
      cgId[0] = 'Monthly BSU';
    }

    //this.state.data.length = 0;
    this.setState(
      {
        alert: cgId[0],
        chechGroupId: cgId[0],
        checkName: cgId[1],
        cgName: chechGroupId,
        data: [],
        dataEmpty: true,
      },
      function () {
        // this.state.data.length = 0;
        this.setState({
          data: [],
        });
      }.bind(this)
    );
  };

  handleInctype = (event) => {
    let chechGroupId = event.target.value;

    this.setState(
      {
        incType: event.target.value,
        data: [],
        chechGroupId: chechGroupId,
      },
      function () {}
    );
  };

  loadCategoryData = (data) => {
    this.setState({
      category: data,
    });
  };

  handleSelect() {
    let alerts = this.state.alert;
    let incTypes = this.state.incType;

    this.setState({
      dataEmpty: false,
    });
    if (this.state.storeValue === '' || this.state.storeValue === null) {
      toast.error('Please select the store', {
        position: 'bottom-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (this.state.alert === '' || this.state.alert === null) {
      toast.error('Please select the checklist name', {
        position: 'bottom-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (this.state.alert === 'Monthly BSU') {
      if (this.state.incType === '' || this.state.incType === null) {
        toast.error('Please select the checklist type', {
          position: 'bottom-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        this.setState({
          loading: true,
        });
        alerts = 0;

        ApiGateWay.Post(
          this.state.apiInterface +
            '/loadChecklistQuestions?checklistGroupId=' +
            incTypes +
            '&appType=Web'
        )
          .then((response) => response.json())
          .then((response) => {
            console.log(JSON.stringify(response));
            if (
              response.errorMessage === 'Token Expired' ||
              response.errorMessage === 'Invalid Token:::JWT expired' ||
              response.errorMessage ===
                'Your session has expired. Please login again.'
            ) {
              Cookie.remove('currentUser');
              Cookie.remove('stores');
              Cookie.remove('storesAll');
              Cookie.remove('warehouses');
              localStorage.clear();
              sessionStorage.clear();
              this.setState({
                loading: false,
                modalOpen: true,
                message:
                  'Your session has been expired and you will be redirected to the login page!!',
              });
              setTimeout(() => {
                return (window.location = '/');
              }, 4000);
            }
            let data = response;

            let checkArray = [];
            let category = [];
            let subCategory = [];
            if (data.categoryInfos) {
              data.categoryInfos.map((item) => {
                let temp = {};
                let tempSubcat = [];
                temp['category'] = item.key;

                item.subCategoryInfos.map((item1) => {
                  let temp1 = [];

                  subCategory.push({ subCategory: item1.key });
                  item1.descriptions.map((item2) => {
                    temp1.push({
                      id: item2.checkListId,
                      name: item2.description,
                    });

                    checkArray.push({
                      id: item2.checkListId,
                      name: item2.description,
                      category: item.key,
                      subCategory: item1.key,
                    });
                  });
                  tempSubcat.push({ subCategory: item1.key, name: temp1 });
                });
                temp['category'] = item.key;
                temp['subCategory'] = tempSubcat;
                category.push(temp);
              });

              this.setState({
                category: category,
              });
            }
            this.setState({
              loading: false,
            });
          })
          .catch((error) => {
            this.setState({
              loading: false,
              modalOpen: true,
              message: 'Unable to retrieve the data. Please try again later',
            });
          });
      }
    } else {
      this.setState({
        loading: true,
      });

      if (this.state.alert === 'Monthly BSU') {
        alerts = 0;

        ApiGateWay.Post(
          this.state.apiInterface +
            '/loadChecklistQuestions?checklistGroupId=' +
            incTypes +
            '&appType=Web'
        )
          .then((response) => response.json())
          .then((response) => {
            if (
              response.errorMessage === 'Token Expired' ||
              response.errorMessage === 'Invalid Token:::JWT expired' ||
              response.errorMessage ===
                'Your session has expired. Please login again.'
            ) {
              Cookie.remove('currentUser');
              Cookie.remove('stores');
              Cookie.remove('storesAll');
              Cookie.remove('warehouses');
              localStorage.clear();
              sessionStorage.clear();
              this.setState({
                loading: false,
                modalOpen: true,
                message:
                  'Your session has been expired and you will be redirected to the login page!!',
              });
              setTimeout(() => {
                return (window.location = '/');
              }, 4000);
            }
            let data = response;

            let checkArray = [];
            let category = [];
            let subCategory = [];
            if (data.categoryInfos) {
              data.categoryInfos.map((item) => {
                let temp = {};
                let tempSubcat = [];
                temp['category'] = item.key;

                item.subCategoryInfos.map((item1) => {
                  let temp1 = [];

                  subCategory.push({ subCategory: item1.key });
                  item1.descriptions.map((item2) => {
                    temp1.push({
                      id: item2.checkListId,
                      name: item2.description,
                    });

                    checkArray.push({
                      id: item2.checkListId,
                      name: item2.description,
                      category: item.key,
                      subCategory: item1.key,
                    });
                  });
                  tempSubcat.push({ subCategory: item1.key, name: temp1 });
                });
                temp['category'] = item.key;
                temp['subCategory'] = tempSubcat;
                category.push(temp);
              });

              this.setState({
                category: category,
              });
            }
            this.setState({
              loading: false,
            });
          })
          .catch((error) => {
            this.setState({
              loading: false,
              modalOpen: true,
              message: 'Unable to retrieve the data. Please try again later',
            });
          });
      } else {
        ApiGateWay.Post(
          this.state.apiInterface +
            '/loadChecklistQuestions?checklistGroupId=' +
            alerts +
            '&appType=Web'
        )
          .then((response) => response.json())
          .then((response) => {
            if (
              response.errorMessage === 'Token Expired' ||
              response.errorMessage === 'Invalid Token:::JWT expired' ||
              response.errorMessage ===
                'Your session has expired. Please login again.'
            ) {
              Cookie.remove('currentUser');
              Cookie.remove('stores');
              Cookie.remove('storesAll');
              Cookie.remove('warehouses');
              localStorage.clear();
              sessionStorage.clear();
              this.setState({
                loading: false,
                modalOpen: true,
                message:
                  'Your session has been expired and you will be redirected to the login page!!',
              });
              setTimeout(() => {
                return (window.location = '/');
              }, 4000);
            }
            let data = response;

            let checkArray = [];
            let category = [];
            let subCategory = [];
            if (data.categoryInfos) {
              data.categoryInfos.map((item) => {
                let temp = {};
                let tempSubcat = [];
                temp['category'] = item.key;

                item.subCategoryInfos.map((item1) => {
                  let temp1 = [];

                  subCategory.push({ subCategory: item1.key });
                  item1.descriptions.map((item2) => {
                    temp1.push({
                      id: item2.checkListId,
                      name: item2.description,
                      questionType: item2.questionType,
                      createdBy:item2?.createdBy,
                    });

                    checkArray.push({
                      id: item2.checkListId,
                      name: item2.description,
                      questionType: item2.questionType,
                      category: item.key,
                      subCategory: item1.key,
                    });
                  });
                  tempSubcat.push({ subCategory: item1.key, name: temp1 });
                });
                temp['category'] = item.key;
                temp['subCategory'] = tempSubcat;
                category.push(temp);
              });

              this.setState({
                category: category,
              });
            }
            this.setState({
              loading: false,
            });
          })
          .catch((error) => {
            this.setState({
              loading: false,
              modalOpen: true,
              message: 'Unable to retrieve the data. Please try again later',
            });
          });
      }
    }
  }

  formatDate = (input) => {
    let input_date = input.toString();
    let datePart = input_date.split('-'),
      year = datePart[0], // get only two digits
      month = datePart[1],
      day = datePart[2];

    return day + '/' + month + '/' + year;
  };

  componentDidMount() {
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? val.featureAccess
          ? val.featureAccess.map((child1, ind) =>
              child1.featureName == 'Edit CheckList' ? (pageAllow = true) : ''
            )
          : ''
        : ''
    );
    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: false,
      });
      ApiGateWay.PostEmp(this.state.apiInterface + '/fetchEmpInfo')
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');
            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }

          this.setState({
            submittedByCodeJson: response,
            visible: true,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }
  }

  render() {
    const { loading, modalOpen, pageAllowed, message } = this.state;
    let future = this.state.user;

    let pageAllow = false;
    return (
      <>
        {future.map((val, index) =>
          val.value == 1
            ? val.featureAccess
              ? val.featureAccess.map((child1, ind) =>
                  child1.value == 1
                    ? child1.featureName == 'Edit CheckList'
                      ? (pageAllow = true)
                      : ''
                    : ''
                )
              : ''
            : ''
        )}
        {pageAllow === false ? (
        
          <Navigate to="/pageNotAllowed" state={{ id:'Edit CheckList' }} />
        ) : (
          ''
        )}
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}

        <div className='wrapper'>
          <Header title={this.state.title} />

          <Menu />
          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content'>
                <div className='row'>
                  <div className='col-md-3 col-lg-3 col-sm-3'>
                    <form style={{ background: 'none', padding: '0% 0%' }}>
                      <div className='form-group'>
                        <select
                          className='form-control'
                          onChange={this.handleStoreValue}
                          value={this.state.storeValue}
                        >
                          <option value='' selected disabled>
                            Select a Store
                          </option>
                          {this.state.selectOption
                            ? this.state.stores
                                .sort((a, b) =>
                                  a.storeName > b.storeName ? 1 : -1
                                )
                                .map((val1) => {
                                  return (
                                    <option
                                      key={val1.storeId}
                                      value={val1.storeId}
                                    >
                                      {val1.storeName}
                                    </option>
                                  );
                                })
                            : null}
                          {this.state.wareHouses
                            .sort((a, b) =>
                              a.storeName > b.storeName ? 1 : -1
                            )
                            .map((val) => {
                              return (
                                <option key={val.storeId} value={val.storeId}>
                                  {val.storeName}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </form>
                  </div>
                </div>
                {true ? (
                  <div className='row'>
                    <form
                      className='form'
                      style={{ background: 'none', padding: '0% 0%' }}
                    >
                      <div className='col-md-3'>
                        <div className='form-group'>
                          <select
                            className='form-control'
                            value={this.state.cgName}
                            onChange={this.handleAlert}
                          >
                            <option value=''>Checklist Name</option>
                            {this.state.storeSelected &&
                            this.state.codeJson.checklistInfos
                              ? this.state.codeJson.checklistInfos.map(
                                  (val) => (
                                    <option
                                      key={val.value}
                                      value={val.value + '+' + val.key}
                                    >
                                      {val.key}
                                    </option>
                                  )
                                )
                              : null}
                          </select>
                        </div>
                      </div>
                      <div className='col-md-3'>
                        <div className='form-group'>
                          <select
                            className='form-control'
                            value={this.state.incType}
                            onChange={this.handleInctype}
                          >
                            <option value=''>Checklist Type</option>
                            {this.state.alert === 'Monthly BSU'
                              ? this.state.codeJson.checklistInfos.map(
                                  (val) => {
                                    return val.key === this.state.alert
                                      ? val.checklistInfos.map((names) => {
                                          return (
                                            <option
                                              key={names.value}
                                              value={names.value}
                                            >
                                              {names.key}
                                            </option>
                                          );
                                        })
                                      : null;
                                  }
                                )
                              : null}
                          </select>
                        </div>
                      </div>

                      <div className='col-md-3'>
                        <button
                          type='button'
                          onClick={this.handleSelect}
                          className='btn btn-secondary deca-btn-yellow'
                        >
                          SUBMIT
                        </button>
                      </div>
                    </form>
                  </div>
                ) : null}
                <br /> <br />
                <div className='row'>
                  <div className='form-group'>
                    <CheckEdit
                      loadCat={this.loadCategoryData}
                      category={this.state.category}
                      refreshData={this.handleSelect}
                      storeId={this.state.storeValue}
                      checkName={this.state.checkName}
                      dataEmpty={this.state.dataEmpty}
                      checkGroupId={this.state.chechGroupId}
                    />
                  </div>
                </div>
              </section>
            )}
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default EditChecklist;
